import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryTabs() {
  const location = useLocation();

  return (
    <section className="w-full px-4 md:px-6 py-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                location.pathname === `/category/${cat.slug}`
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              <span>{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}